<app-page-header title="Gestión de Niveles y Categorías" subtitle="Administra los niveles y categorías de los miembros"></app-page-header>


<div class="card">
    <p-tabView
        styleClass="tabview-custom"
        [(activeIndex)]="modalitieTabIndex"
        (onChange)="onModalitieTabChange($event)">
        
        <p-tabPanel header="ARTISTICO">
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                    <p-avatar image="./assets/img/iconArtistico.jpeg" shape="circle" />
                    <span class="font-bold white-space-nowrap m-0"> Artístico </span>
                </div>
            </ng-template>
            <div class="p-mt-2">
                <!-- Toolbar -->
                <div class="toolbar">
                    <button pButton type="button" 
                            label="Nuevo Nivel" 
                            icon="pi pi-plus" 
                            class="p-button-success"
                            (click)="addNodeItem()">
                    </button>
                </div>

                <!-- TreeTable -->
                <div class="lpa-treetable-compact">
                    <p-treeTable [value]="treeData" 
                                 [columns]="cols" 
                                 styleClass="p-treetable-sm"
                                 [scrollable]="true" 
                                 scrollHeight="600px">
                    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns; let i = index" 
                                [style.width]="col.width"
                                [ngClass]="{
                                    'text-left': i === 0,
                                    'text-center': i > 0
                                }">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
                                
                                <ng-container [ngSwitch]="col.field">
                                    <!-- Nombre con icono según tipo -->
                                    <div *ngSwitchCase="'name'" class="name-cell" [class.level-cell]="rowData.entityType === 'level'" [class.category-cell]="rowData.entityType === 'category'">
                                        <div class="name-content">
                                            <i [class]="rowData.entityType === 'level' ? 'pi pi-sitemap entity-icon level-icon' : 'pi pi-tag entity-icon category-icon'"></i>
                                            <span [class]="rowData.entityType === 'level' ? 'entity-name level-name' : 'entity-name category-name'">
                                                {{rowData.name}}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <!-- Tipo -->
                                    <div *ngSwitchCase="'type'" class="type-cell">
                                        <span class="badge" 
                                              [class.badge-primary]="rowData.entityType === 'level'"
                                              [class.badge-success]="rowData.entityType === 'category'">
                                            {{rowData.type}}
                                        </span>
                                    </div>
                                    
                                    <!-- Estado -->
                                    <div *ngSwitchCase="'status'" class="status-cell">
                                        <span class="badge" 
                                              [class.badge-success]="rowData.status === 'Activo'"
                                              [class.badge-secondary]="rowData.status !== 'Activo'">
                                            {{rowData.status}}
                                        </span>
                                    </div>
                                    
                                    <!-- Acciones -->
                                    <div *ngSwitchCase="'actions'" class="action-buttons">
                                        <button pButton type="button" 
                                                icon="pi pi-plus" 
                                                class="p-button-rounded p-button-success p-button-sm"
                                                *ngIf="rowData.entityType === 'level'"
                                                pTooltip="Agregar Categoría"
                                                tooltipPosition="top"
                                                (click)="addNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-pencil" 
                                                class="p-button-rounded p-button-info p-button-sm"
                                                pTooltip="Editar"
                                                tooltipPosition="top"
                                                (click)="editNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-trash" 
                                                class="p-button-rounded p-button-danger p-button-sm"
                                                pTooltip="Eliminar"
                                                tooltipPosition="top"
                                                (click)="deleteNodeItem(rowNode)">
                                        </button>
                                    </div>
                                    
                                    <!-- Campos por defecto -->
                                    <div *ngSwitchDefault class="default-cell">{{rowData[col.field]}}</div>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="cols.length" class="text-center">
                                No se encontraron registros para esta modalidad
                            </td>
                        </tr>
                    </ng-template>
                    </p-treeTable>
                </div>
            </div>
        </p-tabPanel>
        
        <p-tabPanel header="CARRERAS">
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                    <p-avatar image="./assets/img/iconCarreras.jpeg" shape="circle" />
                    <span class="font-bold white-space-nowrap m-0"> Carreras </span>
                </div>
            </ng-template>
            <div class="p-mt-2">
                <!-- Toolbar -->
                <div class="toolbar">
                    <button pButton type="button" 
                            label="Nuevo Nivel" 
                            icon="pi pi-plus" 
                            class="p-button-success"
                            (click)="addNodeItem()">
                    </button>
                </div>

                <!-- TreeTable -->
                <div class="lpa-treetable-compact">
                    <p-treeTable [value]="treeData" 
                                 [columns]="cols" 
                                 styleClass="p-treetable-sm"
                                 [scrollable]="true" 
                                 scrollHeight="600px">
                    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns; let i = index" 
                                [style.width]="col.width"
                                [ngClass]="{
                                    'text-left': i === 0,
                                    'text-center': i > 0
                                }">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
                                
                                <ng-container [ngSwitch]="col.field">
                                    <!-- Nombre con icono según tipo -->
                                    <div *ngSwitchCase="'name'" class="name-cell" [class.level-cell]="rowData.entityType === 'level'" [class.category-cell]="rowData.entityType === 'category'">
                                        <div class="name-content">
                                            <i [class]="rowData.entityType === 'level' ? 'pi pi-sitemap entity-icon level-icon' : 'pi pi-tag entity-icon category-icon'"></i>
                                            <span [class]="rowData.entityType === 'level' ? 'entity-name level-name' : 'entity-name category-name'">
                                                {{rowData.name}}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <!-- Tipo -->
                                    <div *ngSwitchCase="'type'" class="type-cell">
                                        <span class="badge" 
                                              [class.badge-primary]="rowData.entityType === 'level'"
                                              [class.badge-success]="rowData.entityType === 'category'">
                                            {{rowData.type}}
                                        </span>
                                    </div>
                                    
                                    <!-- Estado -->
                                    <div *ngSwitchCase="'status'" class="status-cell">
                                        <span class="badge" 
                                              [class.badge-success]="rowData.status === 'Activo'"
                                              [class.badge-secondary]="rowData.status !== 'Activo'">
                                            {{rowData.status}}
                                        </span>
                                    </div>
                                    
                                    <!-- Acciones -->
                                    <div *ngSwitchCase="'actions'" class="action-buttons">
                                        <button pButton type="button" 
                                                icon="pi pi-plus" 
                                                class="p-button-rounded p-button-success p-button-sm"
                                                *ngIf="rowData.entityType === 'level'"
                                                pTooltip="Agregar Categoría"
                                                tooltipPosition="top"
                                                (click)="addNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-pencil" 
                                                class="p-button-rounded p-button-info p-button-sm"
                                                pTooltip="Editar"
                                                tooltipPosition="top"
                                                (click)="editNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-trash" 
                                                class="p-button-rounded p-button-danger p-button-sm"
                                                pTooltip="Eliminar"
                                                tooltipPosition="top"
                                                (click)="deleteNodeItem(rowNode)">
                                        </button>
                                    </div>
                                    
                                    <!-- Campos por defecto -->
                                    <div *ngSwitchDefault class="default-cell">{{rowData[col.field]}}</div>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="cols.length" class="text-center">
                                No se encontraron registros para esta modalidad
                            </td>
                        </tr>
                    </ng-template>
                    </p-treeTable>
                </div>
            </div>
        </p-tabPanel>
        
        <p-tabPanel header="HOCKEY">
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                    <p-avatar image="./assets/img/iconHockey.jpeg" shape="circle" />
                    <span class="font-bold white-space-nowrap m-0"> Hockey </span>
                </div>
            </ng-template>
            <div class="p-mt-2">
                <!-- Toolbar -->
                <div class="toolbar">
                    <button pButton type="button" 
                            label="Nuevo Nivel" 
                            icon="pi pi-plus" 
                            class="p-button-success"
                            (click)="addNodeItem()">
                    </button>
                </div>

                <!-- TreeTable -->
                <div class="lpa-treetable-compact">
                    <p-treeTable [value]="treeData" 
                                 [columns]="cols" 
                                 styleClass="p-treetable-sm"
                                 [scrollable]="true" 
                                 scrollHeight="600px">
                    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns; let i = index" 
                                [style.width]="col.width"
                                [ngClass]="{
                                    'text-left': i === 0,
                                    'text-center': i > 0
                                }">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
                                
                                <ng-container [ngSwitch]="col.field">
                                    <!-- Nombre con icono según tipo -->
                                    <div *ngSwitchCase="'name'" class="name-cell" [class.level-cell]="rowData.entityType === 'level'" [class.category-cell]="rowData.entityType === 'category'">
                                        <div class="name-content">
                                            <i [class]="rowData.entityType === 'level' ? 'pi pi-sitemap entity-icon level-icon' : 'pi pi-tag entity-icon category-icon'"></i>
                                            <span [class]="rowData.entityType === 'level' ? 'entity-name level-name' : 'entity-name category-name'">
                                                {{rowData.name}}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <!-- Tipo -->
                                    <div *ngSwitchCase="'type'" class="type-cell">
                                        <span class="badge" 
                                              [class.badge-primary]="rowData.entityType === 'level'"
                                              [class.badge-success]="rowData.entityType === 'category'">
                                            {{rowData.type}}
                                        </span>
                                    </div>
                                    
                                    <!-- Estado -->
                                    <div *ngSwitchCase="'status'" class="status-cell">
                                        <span class="badge" 
                                              [class.badge-success]="rowData.status === 'Activo'"
                                              [class.badge-secondary]="rowData.status !== 'Activo'">
                                            {{rowData.status}}
                                        </span>
                                    </div>
                                    
                                    <!-- Acciones -->
                                    <div *ngSwitchCase="'actions'" class="action-buttons">
                                        <button pButton type="button" 
                                                icon="pi pi-plus" 
                                                class="p-button-rounded p-button-success p-button-sm"
                                                *ngIf="rowData.entityType === 'level'"
                                                pTooltip="Agregar Categoría"
                                                tooltipPosition="top"
                                                (click)="addNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-pencil" 
                                                class="p-button-rounded p-button-info p-button-sm"
                                                pTooltip="Editar"
                                                tooltipPosition="top"
                                                (click)="editNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-trash" 
                                                class="p-button-rounded p-button-danger p-button-sm"
                                                pTooltip="Eliminar"
                                                tooltipPosition="top"
                                                (click)="deleteNodeItem(rowNode)">
                                        </button>
                                    </div>
                                    
                                    <!-- Campos por defecto -->
                                    <div *ngSwitchDefault class="default-cell">{{rowData[col.field]}}</div>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="cols.length" class="text-center">
                                No se encontraron registros para esta modalidad
                            </td>
                        </tr>
                    </ng-template>
                    </p-treeTable>
                </div>
            </div>
        </p-tabPanel>
        
        <p-tabPanel header="SKATEBOARDING">
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-2">
                    <p-avatar image="./assets/img/iconSkate.jpeg" shape="circle" />
                    <span class="font-bold white-space-nowrap m-0"> Skateboarding </span>
                </div>
            </ng-template>
            <div class="p-mt-2">
                <!-- Toolbar -->
                <div class="toolbar">
                    <button pButton type="button" 
                            label="Nuevo Nivel" 
                            icon="pi pi-plus" 
                            class="p-button-success"
                            (click)="addNodeItem()">
                    </button>
                </div>

                <!-- TreeTable -->
                <div class="lpa-treetable-compact">
                    <p-treeTable [value]="treeData" 
                                 [columns]="cols" 
                                 styleClass="p-treetable-sm"
                                 [scrollable]="true" 
                                 scrollHeight="600px">
                    
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th *ngFor="let col of columns; let i = index" 
                                [style.width]="col.width"
                                [ngClass]="{
                                    'text-left': i === 0,
                                    'text-center': i > 0
                                }">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns; let i = index">
                                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
                                
                                <ng-container [ngSwitch]="col.field">
                                    <!-- Nombre con icono según tipo -->
                                    <div *ngSwitchCase="'name'" class="name-cell" [class.level-cell]="rowData.entityType === 'level'" [class.category-cell]="rowData.entityType === 'category'">
                                        <div class="name-content">
                                            <i [class]="rowData.entityType === 'level' ? 'pi pi-sitemap entity-icon level-icon' : 'pi pi-tag entity-icon category-icon'"></i>
                                            <span [class]="rowData.entityType === 'level' ? 'entity-name level-name' : 'entity-name category-name'">
                                                {{rowData.name}}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <!-- Tipo -->
                                    <div *ngSwitchCase="'type'" class="type-cell">
                                        <span class="badge" 
                                              [class.badge-primary]="rowData.entityType === 'level'"
                                              [class.badge-success]="rowData.entityType === 'category'">
                                            {{rowData.type}}
                                        </span>
                                    </div>
                                    
                                    <!-- Estado -->
                                    <div *ngSwitchCase="'status'" class="status-cell">
                                        <span class="badge" 
                                              [class.badge-success]="rowData.status === 'Activo'"
                                              [class.badge-secondary]="rowData.status !== 'Activo'">
                                            {{rowData.status}}
                                        </span>
                                    </div>
                                    
                                    <!-- Acciones -->
                                    <div *ngSwitchCase="'actions'" class="action-buttons">
                                        <button pButton type="button" 
                                                icon="pi pi-plus" 
                                                class="p-button-rounded p-button-success p-button-sm"
                                                *ngIf="rowData.entityType === 'level'"
                                                pTooltip="Agregar Categoría"
                                                tooltipPosition="top"
                                                (click)="addNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-pencil" 
                                                class="p-button-rounded p-button-info p-button-sm"
                                                pTooltip="Editar"
                                                tooltipPosition="top"
                                                (click)="editNodeItem(rowNode)">
                                        </button>
                                        <button pButton type="button" 
                                                icon="pi pi-trash" 
                                                class="p-button-rounded p-button-danger p-button-sm"
                                                pTooltip="Eliminar"
                                                tooltipPosition="top"
                                                (click)="deleteNodeItem(rowNode)">
                                        </button>
                                    </div>
                                    
                                    <!-- Campos por defecto -->
                                    <div *ngSwitchDefault class="default-cell">{{rowData[col.field]}}</div>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="cols.length" class="text-center">
                                No se encontraron registros para esta modalidad
                            </td>
                        </tr>
                    </ng-template>
                    </p-treeTable>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>

<!-- Level Form Dialog -->
<p-dialog [header]="levelDialogHeader" [(visible)]="showLevelForm" [modal]="true" [style]="{width: '50vw'}">
    <form [formGroup]="validateLevelForm">
        <div class="row">
            <div class="col-md-12 mb-3">
                <label for="levelName" class="form-label">Nombre *</label>
                <input pInputText id="levelName" formControlName="name" class="form-control" />
                <div *ngIf="validateLevelForm.get('name')?.invalid && validateLevelForm.get('name')?.touched" 
                     class="text-danger">
                    El nombre es requerido
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="levelModality" class="form-label">Modalidad *</label>
                <p-dropdown [options]="modalityOptions" 
                           formControlName="modality" 
                           id="levelModality"
                           placeholder="Seleccione modalidad" 
                           class="form-control p-0">
                </p-dropdown>
                <div *ngIf="validateLevelForm.get('modality')?.invalid && validateLevelForm.get('modality')?.touched" 
                     class="text-danger">
                    La modalidad es requerida
                </div>
            </div>

            <div class="col-md-6 mb-3">
                <label for="levelActive" class="form-label">Activo *</label>
                <p-selectButton [options]="stateOptions" 
                               formControlName="isActive" 
                               id="levelActive"
                               class="form-control p-0">
                </p-selectButton>
            </div>
        </div>
    </form>

    <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary me-2" (click)="closeLevelDialog()">
            Cancelar
        </button>
        <button *ngIf="isNewLevelForm" type="button" class="btn btn-primary" (click)="addNewLevel()">
            Guardar
        </button>
        <button *ngIf="isUpdateLevelForm" type="button" class="btn btn-primary" (click)="editExistentLevel()">
            Actualizar
        </button>
    </div>
</p-dialog>

<!-- Category Form Dialog -->
<p-dialog [header]="categoryDialogHeader" [(visible)]="showCategoryForm" [modal]="true" [style]="{width: '60vw'}">
    <form [formGroup]="validateCategoryForm">
        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="categoryName" class="form-label">Nombre *</label>
                <input pInputText id="categoryName" formControlName="name" class="form-control" />
                <div *ngIf="validateCategoryForm.get('name')?.invalid && validateCategoryForm.get('name')?.touched" 
                     class="text-danger">
                    El nombre es requerido
                </div>
            </div>

            <div class="col-md-6 mb-3">
                <label for="categoryLevel" class="form-label">Nivel de Categoría *</label>
                <p-dropdown [options]="availableLevels" 
                           optionLabel="name" 
                           optionValue="id"
                           formControlName="idCategoryLevel" 
                           id="categoryLevel"
                           placeholder="Seleccione nivel" 
                           class="form-control p-0">
                </p-dropdown>
                <div *ngIf="validateCategoryForm.get('idCategoryLevel')?.invalid && validateCategoryForm.get('idCategoryLevel')?.touched" 
                     class="text-danger">
                    El nivel de categoría es requerido
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 mb-3">
                <label for="categoryModality" class="form-label">Modalidad *</label>
                <p-dropdown [options]="modalityOptions" 
                           formControlName="modality" 
                           id="categoryModality"
                           placeholder="Seleccione modalidad" 
                           class="form-control p-0">
                </p-dropdown>
                <div *ngIf="validateCategoryForm.get('modality')?.invalid && validateCategoryForm.get('modality')?.touched" 
                     class="text-danger">
                    La modalidad es requerida
                </div>
            </div>

            <div class="col-md-4 mb-3">
                <label for="minAge" class="form-label">Edad Mínima *</label>
                <input type="number" pInputText id="minAge" formControlName="minYearsOld" class="form-control" min="0" />
                <div *ngIf="validateCategoryForm.get('minYearsOld')?.invalid && validateCategoryForm.get('minYearsOld')?.touched" 
                     class="text-danger">
                    La edad mínima es requerida
                </div>
            </div>

            <div class="col-md-4 mb-3">
                <label for="maxAge" class="form-label">Edad Máxima *</label>
                <input type="number" pInputText id="maxAge" formControlName="maxYearsOld" class="form-control" min="0" />
                <div *ngIf="validateCategoryForm.get('maxYearsOld')?.invalid && validateCategoryForm.get('maxYearsOld')?.touched" 
                     class="text-danger">
                    La edad máxima es requerida
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mb-3">
                <label for="categoryDescription" class="form-label">Descripción *</label>
                <textarea pInputTextarea 
                         id="categoryDescription" 
                         formControlName="description" 
                         rows="3" 
                         class="form-control">
                </textarea>
                <div *ngIf="validateCategoryForm.get('description')?.invalid && validateCategoryForm.get('description')?.touched" 
                     class="text-danger">
                    La descripción es requerida
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="categoryStatus" class="form-label">Estado *</label>
                <p-selectButton [options]="categoryStatusOptions" 
                               formControlName="isActive" 
                               id="categoryStatus"
                               class="form-control p-0">
                </p-selectButton>
                <div *ngIf="validateCategoryForm.get('isActive')?.invalid && validateCategoryForm.get('isActive')?.touched" 
                     class="text-danger">
                    El estado es requerido
                </div>
            </div>
        </div>
    </form>

    <div class="d-flex justify-content-end mt-3">
        <button type="button" class="btn btn-secondary me-2" (click)="closeCategoryDialog()">
            Cancelar
        </button>
        <button *ngIf="isNewCategoryForm" type="button" class="btn btn-primary" (click)="addNewCategory()">
            Guardar
        </button>
        <button *ngIf="isUpdateCategoryForm" type="button" class="btn btn-primary" (click)="editExistentCategory()">
            Actualizar
        </button>
    </div>
</p-dialog>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>